import { ia, iaRa, inRn } from 'lib/helpers/utility';

import { primaryCalculation } from 'components/public/lib/utils';
import { invoicePreviewKeys } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceTable/lib/constants';

export const summarizeInvoices = (invoices) => {
  const summary = {
    coPay: 0,
    coInsurance: 0,
    deductible: 0,
    discount: 0,
    patientAdjustments: 0,
    insuranceAdjustments: 0,
    primaryPatientAdjustments: 0
  };

  for (const inv of invoices) {
    summary.coPay += inv.last_applied?.co_payment?.value ?? 0;
    summary.coInsurance += inv.last_applied?.co_insurance?.value ?? 0;
    summary.deductible += inv.last_applied?.deductible?.value ?? 0;
    summary.discount += inv.discount ?? inv.discountAmount ?? 0;

    for (const proc of inv.procedures || []) {
      if (proc.adjustment) {
        summary.patientAdjustments += primaryCalculation(proc).ins_adjustment;
      }

      if (ia(proc.primary?.[0]?.ins_adj)) {
        summary.insuranceAdjustments += proc.primary[0].ins_adj.reduce(
          (sum, a) => sum + Number(a.amount || 0),
          0
        );
      }

      if (ia(proc.primary?.[0]?.pt_adj)) {
        summary.primaryPatientAdjustments += proc.primary[0].pt_adj.reduce(
          (sum, a) => sum + Number(a.amount || 0),
          0
        );
      }
    }
  }

  return summary;
};

export const getTotals = (invoices) => {
  return iaRa(invoices).reduce(
    (acc, curr) => {
      const stateTax = iaRa(curr.procedures).reduce((procAcc, procCurr) => {
        return procAcc + inRn(procCurr.state_tax_rate);
      }, 0);
      const localTax = iaRa(curr.procedures).reduce((procAcc, procCurr) => {
        return procAcc + inRn(procCurr.local_tax_rate);
      }, 0);

      acc.total += inRn(curr?.total_amount);
      acc.discount += inRn(curr?.discount);
      acc.write_off += inRn(curr?.write_off);
      acc.stateTax += stateTax;
      acc.localTax += localTax;
      acc.otherAdjustments += inRn(curr?.other_adjustments);
      acc.dueAmount += inRn(curr?.invoice_balance);
      acc.tax += inRn(curr?.tax);
      acc.patientPaid += inRn(curr?.amount_paid);
      acc.insuranceAdjustments += inRn(curr?.ins_adjustment);
      acc.insurancePaid += inRn(curr?.ins_payment);

      return acc;
    },
    {
      total: 0,
      discount: 0,
      tax: 0,
      write_off: 0,
      stateTax: 0,
      localTax: 0,
      otherAdjustments: 0,
      dueAmount: 0,
      insuranceAdjustments: 0,
      patientPaid: 0,
      insurancePaid: 0
    }
  );
};

const PATIENT_FIELD_KEYS = invoicePreviewKeys
  .filter(({ property_of }) => property_of === 'patient')
  .map(({ value }) => value);

export const areAllPatientFieldsHidden = (hiddenFields) =>
  PATIENT_FIELD_KEYS.every((key) => iaRa(hiddenFields).includes(key));

export const isPatientRedacted = (invoice) =>
  !!invoice?.patient?.id &&
  !invoice.patient.f_name &&
  !areAllPatientFieldsHidden(invoice?.hidden_fields);
